"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = { class: "sidebar_item sidebar_item--settings" };
const _hoisted_2 = ["title"];
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_preferences_dialog = (0, vue_1.resolveComponent)("preferences-dialog");
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_1, [
        (0, vue_1.createElementVNode)("i", {
            class: (0, vue_1.normalizeClass)(["sidebar_icon sidebar_icon--settings", { 'sidebar_item--is-active': _ctx.preferencesPanelOpen }]),
            title: _ctx.$t('Player Settings'),
            onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.preferencesPanelOpen = !_ctx.preferencesPanelOpen))
        }, null, 10, _hoisted_2),
        (0, vue_1.withDirectives)((0, vue_1.createVNode)(_component_preferences_dialog, {
            onOkButtonClicked: _cache[1] || (_cache[1] = ($event) => (_ctx.preferencesPanelOpen = false)),
            preferencesManager: _ctx.preferencesManager
        }, null, 8, ["preferencesManager"]), [
            [vue_1.vShow, _ctx.preferencesPanelOpen]
        ])
    ]));
}
